import React from 'react';
import cx from 'classnames';

import { usePageWidgetSelector } from '../../core/hooks';

import { BackgroundView } from '../../background';

import styles from './column.module.scss';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';



const SectionColumnWidgetComponent = ({ className, style, widgetProps, breakpoint, children, columnGap }) => {
  const id = get(widgetProps, 'uid');
  const type = get(widgetProps, 'type');

  const background = get(widgetProps, 'properties.desktop.background');
  const layout = get(widgetProps, 'properties.desktop.layout');

  const visibleWidth = get(widgetProps, `properties.${breakpoint}.container.minWidth`);

  const widgetStyle = {
    ...style,
    transform: 'none',
    ...getStyles(widgetProps, breakpoint, columnGap)
  }

  return (
    <div id={id}
      className={cx(className, styles.column, 'cs_column')}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView background={background} breakpoint={breakpoint} />
      <div className={styles.inner}>
        {children}
      </div>
    </div>
  );
};

function getStyles(widget, breakpoint, columnGap) {
  var styles = {};

  if (breakpoint === 'desktop') {
    const width = parseFloat(get(widget, `properties.${breakpoint}.layout.width`, 100));

    styles = {
      ...styles,
      maxWidth: `calc(${width}% - ${columnGap}px)`,
      height: '100%'
    }
  }

  return styles;
}


const sectionColumnWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = pick(nextProps, paths);
  const previous = pick(prevProps, paths);

  const equals = isEqual(next, previous);
  return equals;
}

export const SectionColumnWidget = React.memo(SectionColumnWidgetComponent, sectionColumnWidgetEquals);

